// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    EnrollmentResponseModel,
    ExtEnrollmentCreatePrescriberRequestModel,
    ExtEnrollmentCreatePrescriberResultModelResponse,
    ExtEnrollmentCreateSiteRequestModel,
    ExtEnrollmentCreateSiteResultModelResponse,
    ExtEnrollmentHybridEnrollmentRequestModel,
    ExtEnrollmentHybridEnrollmentResultModelResponse,
    ExtEnrollmentMedBenEnrollmentUpdateRequestModel,
    ExtEnrollmentPatientLookupRequestModel,
    ExtEnrollmentPatientSearchRequestModel,
    ExtEnrollmentPatientUpdateRequestModel,
    GatewayError,
    PatientLookupRequestModel,
    PlpAccountRegisterAccount,
    PlpAccountType,
    PlpClaimSubmitClaimResponse,
    PlpPatientGetEnrollmentsResponse,
    PlpPatientPatientLookupResponse,
    PlpV2PatientPatientLookupResponse,
    PlpV2PatientPatientSearchResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class EdgePlpApi extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @param plpAccountRegisterAccount default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async accountRegister (plpAccountRegisterAccount: PlpAccountRegisterAccount, xProgramId?: string): Promise<AxiosResponse<PlpAccountType>> {
        const _url_ = '/edge/plp/Account/register';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'plpAccountRegisterAccount' is not null or undefined
        if (plpAccountRegisterAccount === null || plpAccountRegisterAccount === undefined) {
            throw new Error('Required parameter plpAccountRegisterAccount was null or undefined when calling accountRegister.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(plpAccountRegisterAccount, "PlpAccountRegisterAccount"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PlpAccountType>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpAccountType");
        }
        return response;
    }
    /**
     * 
     * @param docType 
     * @param files 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async claimSubmitClaim (docType: number, files: Array<RequestFile>, xProgramId?: string): Promise<AxiosResponse<PlpClaimSubmitClaimResponse>> {
        const _url_ = '/edge/plp/Claim/submitClaim';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'docType' is not null or undefined
        if (docType === null || docType === undefined) {
            throw new Error('Required parameter docType was null or undefined when calling claimSubmitClaim.');
        }

        // verify required parameter 'files' is not null or undefined
        if (files === null || files === undefined) {
            throw new Error('Required parameter files was null or undefined when calling claimSubmitClaim.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const formData = new FormData();
        if (docType !== undefined) {
            formData.append(
                'docType',
                Serializer.serialize(
                    docType,
                    "number"
                ),
            );
        }

        if (files !== undefined) {
            formData.append(
                'files',
                typeof files === 'object' && 'value' in files
                    ? files.value
                    : files,
                typeof files === 'object' && 'options' in files
                    ? files.options
                    : undefined as any
            );
        }

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: formData,
        };
        if (formData.getHeaders) {
            Object.assign(_headers_, formData.getHeaders());
        }

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PlpClaimSubmitClaimResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpClaimSubmitClaimResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentHybridEnrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollPatientEnrollPatient (extEnrollmentHybridEnrollmentRequestModel: ExtEnrollmentHybridEnrollmentRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtEnrollmentHybridEnrollmentResultModelResponse>> {
        const _url_ = '/edge/plp/Enrollment/enrollPatient';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentHybridEnrollmentRequestModel' is not null or undefined
        if (extEnrollmentHybridEnrollmentRequestModel === null || extEnrollmentHybridEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentHybridEnrollmentRequestModel was null or undefined when calling enrollPatientEnrollPatient.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentHybridEnrollmentRequestModel, "ExtEnrollmentHybridEnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtEnrollmentHybridEnrollmentResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentHybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentMedBenEnrollmentUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollPatientEnrollmentUpdate (extEnrollmentMedBenEnrollmentUpdateRequestModel: ExtEnrollmentMedBenEnrollmentUpdateRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtEnrollmentHybridEnrollmentResultModelResponse>> {
        const _url_ = '/edge/plp/Enrollment/enrollmentUpdate';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentMedBenEnrollmentUpdateRequestModel' is not null or undefined
        if (extEnrollmentMedBenEnrollmentUpdateRequestModel === null || extEnrollmentMedBenEnrollmentUpdateRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentMedBenEnrollmentUpdateRequestModel was null or undefined when calling enrollPatientEnrollmentUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentMedBenEnrollmentUpdateRequestModel, "ExtEnrollmentMedBenEnrollmentUpdateRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtEnrollmentHybridEnrollmentResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentHybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentHybridEnrollmentRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async enrollPatientExpressEnrollment (extEnrollmentHybridEnrollmentRequestModel: ExtEnrollmentHybridEnrollmentRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtEnrollmentHybridEnrollmentResultModelResponse>> {
        const _url_ = '/edge/plp/Enrollment/expressEnrollment';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentHybridEnrollmentRequestModel' is not null or undefined
        if (extEnrollmentHybridEnrollmentRequestModel === null || extEnrollmentHybridEnrollmentRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentHybridEnrollmentRequestModel was null or undefined when calling enrollPatientExpressEnrollment.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentHybridEnrollmentRequestModel, "ExtEnrollmentHybridEnrollmentRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtEnrollmentHybridEnrollmentResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentHybridEnrollmentResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientGetEnrollments (xProgramId?: string): Promise<AxiosResponse<PlpPatientGetEnrollmentsResponse>> {
        const _url_ = '/edge/plp/Patient/getEnrollments';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PlpPatientGetEnrollmentsResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpPatientGetEnrollmentsResponse");
        }
        return response;
    }
    /**
     * 
     * @param patientLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientPatientLookup (patientLookupRequestModel: PatientLookupRequestModel, xProgramId?: string): Promise<AxiosResponse<PlpPatientPatientLookupResponse>> {
        const _url_ = '/edge/plp/Patient/patientLookup';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'patientLookupRequestModel' is not null or undefined
        if (patientLookupRequestModel === null || patientLookupRequestModel === undefined) {
            throw new Error('Required parameter patientLookupRequestModel was null or undefined when calling patientPatientLookup.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(patientLookupRequestModel, "PatientLookupRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PlpPatientPatientLookupResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpPatientPatientLookupResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentPatientUpdateRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientUpdate (extEnrollmentPatientUpdateRequestModel: ExtEnrollmentPatientUpdateRequestModel, xProgramId?: string): Promise<AxiosResponse<EnrollmentResponseModel>> {
        const _url_ = '/edge/plp/Patient/update';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentPatientUpdateRequestModel' is not null or undefined
        if (extEnrollmentPatientUpdateRequestModel === null || extEnrollmentPatientUpdateRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentPatientUpdateRequestModel was null or undefined when calling patientUpdate.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'PUT',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentPatientUpdateRequestModel, "ExtEnrollmentPatientUpdateRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<EnrollmentResponseModel>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "EnrollmentResponseModel");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentPatientLookupRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientV2PatientLookup (extEnrollmentPatientLookupRequestModel: ExtEnrollmentPatientLookupRequestModel, xProgramId?: string): Promise<AxiosResponse<PlpV2PatientPatientLookupResponse>> {
        const _url_ = '/edge/plp/v2/Patient/patientLookup';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentPatientLookupRequestModel' is not null or undefined
        if (extEnrollmentPatientLookupRequestModel === null || extEnrollmentPatientLookupRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentPatientLookupRequestModel was null or undefined when calling patientV2PatientLookup.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentPatientLookupRequestModel, "ExtEnrollmentPatientLookupRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PlpV2PatientPatientLookupResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpV2PatientPatientLookupResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentPatientSearchRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async patientV2PatientSearch (extEnrollmentPatientSearchRequestModel: ExtEnrollmentPatientSearchRequestModel, xProgramId?: string): Promise<AxiosResponse<PlpV2PatientPatientSearchResponse>> {
        const _url_ = '/edge/plp/v2/Patient/patientSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentPatientSearchRequestModel' is not null or undefined
        if (extEnrollmentPatientSearchRequestModel === null || extEnrollmentPatientSearchRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentPatientSearchRequestModel was null or undefined when calling patientV2PatientSearch.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentPatientSearchRequestModel, "ExtEnrollmentPatientSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<PlpV2PatientPatientSearchResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "PlpV2PatientPatientSearchResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentCreatePrescriberRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async prescriberCreatePrescriber (extEnrollmentCreatePrescriberRequestModel: ExtEnrollmentCreatePrescriberRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtEnrollmentCreatePrescriberResultModelResponse>> {
        const _url_ = '/edge/plp/Prescriber/createPrescriber';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentCreatePrescriberRequestModel' is not null or undefined
        if (extEnrollmentCreatePrescriberRequestModel === null || extEnrollmentCreatePrescriberRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentCreatePrescriberRequestModel was null or undefined when calling prescriberCreatePrescriber.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentCreatePrescriberRequestModel, "ExtEnrollmentCreatePrescriberRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtEnrollmentCreatePrescriberResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentCreatePrescriberResultModelResponse");
        }
        return response;
    }
    /**
     * 
     * @param extEnrollmentCreateSiteRequestModel default request body
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async siteCreateSite (extEnrollmentCreateSiteRequestModel: ExtEnrollmentCreateSiteRequestModel, xProgramId?: string): Promise<AxiosResponse<ExtEnrollmentCreateSiteResultModelResponse>> {
        const _url_ = '/edge/plp/Site/createSite';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'extEnrollmentCreateSiteRequestModel' is not null or undefined
        if (extEnrollmentCreateSiteRequestModel === null || extEnrollmentCreateSiteRequestModel === undefined) {
            throw new Error('Required parameter extEnrollmentCreateSiteRequestModel was null or undefined when calling siteCreateSite.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "string");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(extEnrollmentCreateSiteRequestModel, "ExtEnrollmentCreateSiteRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<ExtEnrollmentCreateSiteResultModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "ExtEnrollmentCreateSiteResultModelResponse");
        }
        return response;
    }
}
